import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, CardContent, Typography } from "@mui/material";
import useNewsData from "../hooks/useNewsData";

const NewsCarousel: React.FC = () => {
  const { newsData } = useNewsData();

  return (
    <Slider
      dots={true}
      infinite={true}
      speed={1000}
      autoplaySpeed={5000}
      autoplay={true}
      pauseOnHover={true}
    >
      {newsData.map((news, index) => {
        return (
          <div key={index}>
            <CardContent
              sx={{
                p: 2,
                minHeight: 230,
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {news.Imagen ? (
                <Box
                  sx={{
                    height: 180,
                    mb: 2,
                    borderRadius: "16px",
                    overflow: "hidden",
                    border: "2px solid rgba(62, 80, 147, 0.18)",
                  }}
                >
                  <Box
                    component="img"
                    src={news.Imagen}
                    alt={news.Titulo}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              ) : null}
              <Typography
                sx={{
                  color: "var(--dashboard-text)",
                  fontWeight: 900,
                  mb: 0.8,
                  fontSize: "1.85rem",
                  lineHeight: 1.1,
                }}
              >
                {news.Titulo}
              </Typography>
              <Typography
                sx={{
                  color: "var(--dashboard-text)",
                  fontWeight: 700,
                  mb: 0.8,
                  fontSize: "1.15rem",
                  lineHeight: 1.2,
                }}
              >
                {news.Subtitle}
              </Typography>
              <Typography
                sx={{
                  color: "var(--dashboard-text)",
                  mb: 1.5,
                  fontSize: "1.05rem",
                  lineHeight: 1.3,
                  flex: 1,
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {news.Cuerpo}
              </Typography>
            </CardContent>
          </div>
        );
      })}
    </Slider>
  );
};

export default NewsCarousel;
